import React, { useState } from "react";
import "./RotateDeviceOverlay.css";

// Shown only on phones in portrait, AND only on chart views (not overview/menu).
// SUPERADMIN only for now (live-testing phase).
export default function RotateDeviceOverlay() {
  const [dismissed, setDismissed] = useState(false);
  const [currentView, setCurrentView] = useState(() =>
    sessionStorage.getItem("adm_current_view") || ""
  );
  const [isReady, setIsReady] = useState(false);

  // Wait 300ms on mount before showing, so sessionStorage has time to populate
  React.useEffect(() => {
    const timer = setTimeout(() => setIsReady(true), 300);
    return () => clearTimeout(timer);
  }, []);

  // Listen for view changes and re-read sessionStorage
  React.useEffect(() => {
    const handleViewChange = () => {
      setCurrentView(sessionStorage.getItem("adm_current_view") || "");
    };
    window.addEventListener("viewChanged", handleViewChange);
    return () => window.removeEventListener("viewChanged", handleViewChange);
  }, []);

  const storedUser = JSON.parse(localStorage.getItem("adm_panel_user") || "{}");
  if (storedUser.role !== "SUPERADMIN") return null;

  // Don't show until 300ms has passed (gives sessionStorage time to populate)
  if (!isReady) return null;

  // Show on all views EXCEPT Overview
  if (currentView === "Overview") {
    console.log("RotateOverlay: Overview page, skip");
    return null;
  }
  if (dismissed) {
    console.log("RotateOverlay: user dismissed it");
    return null;
  }
  if (storedUser.role !== "SUPERADMIN") {
    console.log("RotateOverlay: not SUPERADMIN. role=", storedUser.role);
    return null;
  }

  console.log("RotateOverlay: SHOWING");

  return (
    <div className="rotate-overlay" role="alertdialog" aria-label="Rotate your device">
      <div className="rotate-overlay__card">
        <div className="rotate-overlay__icon">📱</div>
        <p className="rotate-overlay__title">Please rotate your device</p>
        <p className="rotate-overlay__title rotate-overlay__title--tr">
          Lütfen telefonunuzu yan çevirin
        </p>
        <p className="rotate-overlay__sub">
          This page looks best in landscape.
          <br />
          Bu sayfa yatay modda daha iyi görünür.
        </p>
        <button
          className="rotate-overlay__skip"
          onClick={() => setDismissed(true)}
        >
          Skip / Geç
        </button>
      </div>
    </div>
  );
}
